import { Typography, useTheme } from "@mui/material";
import { useRouter } from "next/router";
import Link from "next/link";
import React from "react";
export const Item = ({ isSticky = false, label, route, }) => {
    const theme = useTheme();
    const router = useRouter();
    const isActive = router?.asPath === route || (router?.asPath?.startsWith(route) && route !== "/");
    const stickyStyles = {
        opacity: isActive ? 1 : 0.65,
        "&:hover": {
            opacity: 1,
        },
    };
    const underlineStyles = {
        "&:hover": {
            "&:before": {
                opacity: 1,
            },
        },
        "&:before": {
            transition: theme.transitions.create("opacity", { duration: 200 }),
            opacity: isActive ? 1 : 0,
            background: "white",
            content: "''",
            height: "3px",
            position: "absolute",
            width: "100%",
            bottom: theme.spacing(-1),
            left: 0,
        },
    };
    return (React.createElement(Link, { passHref: true, href: route, legacyBehavior: true },
        React.createElement(Typography, { component: "a", color: "secondary", variant: "body1", sx: {
                ...(isSticky ? stickyStyles : underlineStyles),
                fontWeight: 500,
                m: 0,
                p: 0,
                position: "relative",
                textDecoration: "none",
                textTransform: "uppercase",
                transition: theme.transitions.create("opacity"),
            } }, label)));
};
//# sourceMappingURL=item.js.map